import axios from 'src/lib/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/stay/search/`;

export type StaySearchResult = {
    id: string;
    ref: string;
    exit_time: string | null;
};

interface DTO {
    parkingId: string;
    ref?: string;
    license_plate?: string;
}

const searchStay = ({ parkingId, ref, license_plate }: DTO): Promise<StaySearchResult> =>
    axios.get(formatResourcePath(RESOURCE, { parkingId }), { params: { ref, license_plate } });

export { RESOURCE as SEARCH_STAY_RESOURCE, searchStay };
